import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBarProps {
  defaultValue?: string;
  placeholder?: string;
  size?: "md" | "lg";
}

export default function SearchBar({
  defaultValue = "",
  placeholder = "搜索剧情、角色或资讯关键词…",
  size = "md",
}: SearchBarProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const kw = value.trim();
    navigate(kw ? `/search?q=${encodeURIComponent(kw)}` : "/search");
  };

  const isLarge = size === "lg";

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={`flex items-center w-full bg-background-50 border border-background-300 rounded-full overflow-hidden focus-within:border-primary-400 transition-colors ${
        isLarge ? "h-14 pl-5 pr-1.5" : "h-11 pl-4 pr-1"
      }`}
    >
      <span className={`flex items-center justify-center text-foreground-400 ${isLarge ? "w-5 h-5 mr-3" : "w-4 h-4 mr-2.5"}`}>
        <i className={isLarge ? "ri-search-line text-xl" : "ri-search-line text-base"}></i>
      </span>
      <input
        type="search"
        name="q"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className={`flex-1 min-w-0 bg-transparent outline-none text-foreground-900 placeholder:text-foreground-400 ${isLarge ? "text-base" : "text-sm"}`}
      />
      <button
        type="submit"
        className={`shrink-0 rounded-full bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap ${
          isLarge ? "px-7 h-11 text-sm" : "px-5 h-9 text-sm"
        }`}
      >
        搜索
      </button>
    </form>
  );
}